
import type { Article } from "@/types/article";

export type User = {
  id: number | string;
  name: string;
  email: string;
  role: string;
  subscription: string;
  joinDate: string;
  lastActive: string;
};

export const mockUsers: User[] = [
  {
    id: 1,
    name: "John Doe",
    email: "john@example.com",
    role: "admin",
    subscription: "enterprise",
    joinDate: "2025-01-15",
    lastActive: "2025-04-20"
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    role: "user",
    subscription: "pro",
    joinDate: "2025-02-10",
    lastActive: "2025-04-19"
  },
  {
    id: 3,
    name: "Bob Johnson",
    email: "bob@example.com",
    role: "user",
    subscription: "basic",
    joinDate: "2025-03-05",
    lastActive: "2025-04-15"
  },
  {
    id: 4,
    name: "Sarah Williams",
    email: "sarah@example.com",
    role: "admin",
    subscription: "enterprise",
    joinDate: "2025-01-20",
    lastActive: "2025-04-21"
  }
];

export const allArticles: Article[] = [
  {
    id: 1,
    title: "Understanding Large Language Models",
    description: "A deep dive into how LLMs work and their capabilities.",
    category: "AI Fundamentals",
    premium: false,
    readTime: "8 min read",
    date: "Apr 12, 2025",
    image: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7",
    status: "published",
    author: "AI Team",
    views: 1240
  },
  {
    id: 2,
    title: "The Future of Generative AI in Enterprise",
    description: "How businesses are leveraging AI for competitive advantage.",
    category: "Business",
    premium: true,
    readTime: "12 min read",
    date: "Apr 10, 2025",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475",
    status: "published",
    author: "Business Team",
    views: 980
  },
  {
    id: 3,
    title: "AI Ethics: Navigating the Challenges",
    description: "Exploring ethical considerations in artificial intelligence development.",
    category: "Ethics",
    premium: false,
    readTime: "10 min read",
    date: "Apr 8, 2025",
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6",
    status: "review",
    author: "Ethics Committee",
    views: 756
  },
  {
    id: 4,
    title: "Deep Reinforcement Learning Explained",
    description: "How machines learn to make decisions through trial and error.",
    category: "Technical",
    premium: true,
    readTime: "15 min read",
    date: "Apr 6, 2025",
    image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d",
    status: "draft",
    author: "Technical Team",
    views: 1120
  },
  {
    id: 5,
    title: "Computer Vision: The Evolution of AI Sight",
    description: "From pixel recognition to understanding visual context.",
    category: "AI Fundamentals",
    premium: false,
    readTime: "11 min read",
    date: "Apr 4, 2025",
    image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d",
    status: "published",
    author: "Computer Vision Team",
    views: 890
  },
  {
    id: 6,
    title: "AI Startups to Watch in 2025",
    description: "Emerging companies shaping the future of artificial intelligence.",
    category: "Business",
    premium: true,
    readTime: "9 min read",
    date: "Apr 2, 2025",
    image: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b",
    status: "published",
    author: "Market Research Team",
    views: 1450
  },
];

